<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Hello A. Jones,<br /><br />

    We are very pleased that you have entrusted our company with the renovation
    works. We hereby confirm that we will be carrying out the work in office
    number 6 from 29 August to 2 September. We will send you a separate mail
    regarding the expected costs.<br /><br />

    Sincerely<br />

    BAM Construction Portland<br /><br />

    Feel free to contact us:<br />

    443 Park Lane, Portland <br />
    +1(0)270-681-8943<br />
    info@constructioncompanyPortland.com
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
